import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useGetProgramCollectionById } from '../../../../redux/api/programsAPI';
import { Paths } from '../../../../shared/paths';
import ProgramItemsList from '../../shared/program-items-list/ProgramItemsList';

function ProgramCollectionItems(props) {
  const { programId } = props;
  const { t } = useTranslation();
  const {
    data: programCollection,
    isFetching,
    isLoading,
    error,
    refetch,
  } = useGetProgramCollectionById(programId);
  const { navigate } = useNavigationStack();
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading: isLoading || isFetching,
    hasData: Boolean(programCollection?.programItems?.length),
    onRetry: handleRetry,
  });

  function onAddClick() {
    navigate(
      `${Paths.programs.toNewItem}?programCollectionId=${programCollection?.id}`,
    );
  }

  return (
    <ProgramItemsList
      programItems={programCollection?.programItems || []}
      onAddClick={onAddClick}
      isLoading={isLoading || isFetching}
    />
  );
}

export default ProgramCollectionItems;
